import WHATSAPP_CONSTANTS, { ADMIN_NOTES_CONSTANTS } from "../constants/constantsConstants"

const initialState = {
  message: '',
  loading: false,
  error: null,
  isUpdated: false,
}

export const whatsAppMessageReducer = (state = initialState, action) => {
  switch (action.type) {
    case WHATSAPP_CONSTANTS.GET_WHATSAPP_MESSAGE_REQUEST:
      return { ...state, loading: true, error: null }
    case WHATSAPP_CONSTANTS.GET_WHATSAPP_MESSAGE_SUCCESS:
      return { ...state, loading: false, message: action.payload }
    case WHATSAPP_CONSTANTS.GET_WHATSAPP_MESSAGE_FAIL:
      return { ...state, loading: false, error: action.payload }
    case WHATSAPP_CONSTANTS.UPDATE_WHATSAPP_MESSAGE_REQUEST:
      return { ...state, loading: true, error: null, isUpdated: false }
    case WHATSAPP_CONSTANTS.UPDATE_WHATSAPP_MESSAGE_SUCCESS:
      return { ...state, loading: false, message: action.payload, isUpdated: true }
    case WHATSAPP_CONSTANTS.UPDATE_WHATSAPP_MESSAGE_FAIL:
      return { ...state, loading: false, error: action.payload, isUpdated: false }
    case WHATSAPP_CONSTANTS.UPDATE_WHATSAPP_MESSAGE_RESET:
      return initialState
    default:
      return state
  }
}

const adminNotesInitialState = {
  notes: '',
  loading: false,
  error: null,
  isUpdated: false,
}

export const adminNotesReducer = (state = adminNotesInitialState, action) => {
  switch (action.type) {
    case ADMIN_NOTES_CONSTANTS.GET_ADMIN_NOTES_REQUEST:
      return { ...state, loading: true, error: null }
    case ADMIN_NOTES_CONSTANTS.GET_ADMIN_NOTES_SUCCESS:
      return { ...state, loading: false, notes: action.payload }
    case ADMIN_NOTES_CONSTANTS.GET_ADMIN_NOTES_FAIL:
      return { ...state, loading: false, error: action.payload }
    case ADMIN_NOTES_CONSTANTS.UPDATE_ADMIN_NOTES_REQUEST:
      return { ...state, loading: true, error: null, isUpdated: false }
    case ADMIN_NOTES_CONSTANTS.UPDATE_ADMIN_NOTES_SUCCESS:
      return { ...state, loading: false, notes: action.payload, isUpdated: true }
    case ADMIN_NOTES_CONSTANTS.UPDATE_ADMIN_NOTES_FAIL:
      return { ...state, loading: false, error: action.payload, isUpdated: false }
    case ADMIN_NOTES_CONSTANTS.UPDATE_ADMIN_NOTES_RESET:
      return adminNotesInitialState
    default:
      return state
  }
}